import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import axios from 'axios';
import SyncIcon from '@mui/icons-material/Sync';
import CircularProgress from '@mui/material/CircularProgress';
import {
  Typography,
  FormControl,
  Pagination,
  IconButton,
  Tooltip,
  Modal,
  Box,
  Button,
  Card,
  Alert,
  CardContent,
  CardHeader,
  Collapse
} from "@mui/material";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import ClearIcon from "@mui/icons-material/Clear";
import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import Snackbar from "@mui/material/Snackbar";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { fetchOrderDetail } from "../../pages/OrderDetail/orderdetailsSlice";
import NorowsData from "../../pages/General/NorowsData";
import LinearProgress from "@mui/material/LinearProgress";
import Printer from "../../pages/General/Printer";
import { resetOrderNotifications } from "../../pages/Orders-new/ordersSlice";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
  fetchPickOrderDetail,
  fetchPickOrderDetailitems,
  putOrderItemsDetails,
  resetOrderPickNotification,
  clearPicklistItemOrderNotification
} from "./orderpicklistSlice";

import styled from "@emotion/styled";
import { columnsFromBackend } from "./KanbanData";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import NewOrderCreateDrawer from "../General/NewOrder/NewOrderCreateDrawer";
import Notification from "../../pages/General/Notification";

import TaskCard from "./TaskCard";
import { current } from "@reduxjs/toolkit";
import { Check } from "@material-ui/icons";
import { ConstructionOutlined } from "@mui/icons-material";

// import Date from "../../../pages/General/Date";

//Custom Components Import Ends
const Container = styled.div`
  display: flex;
`;
const PulseBox = styled(Box)`
  @keyframes pulse-green {
    0% { boxShadow: 0 0 0 0 rgba(46, 125, 50, 0.7); }
    70% { boxShadow: 0 0 0 10px rgba(46, 125, 50, 0); }
    100% { boxShadow: 0 0 0 0 rgba(46, 125, 50, 0); }
  }
  animation: pulse-green 2s infinite;
`;
const TaskList = styled.div`
  max-height: 400px;
  overflow-x: scroll;
  display: flex;
  flex-direction: column;
  background: #f3f3f3;
  min-width: 341px;
  border-radius: 5px;
  padding: 15px 15px;
  margin-right: 45px;
`;

const TaskColumnStyles = styled.div`
  margin: 8px;
  display: flex;
  width: 100%;
`;

const Title = styled.span`
  color: #131313;
  font-weight: 600;
  background: #deebff;
  padding: 2px 10px;
  border-radius: 5px;
  align-self: flex-start;
  text-transform: uppercase;
`;
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const PicklistPageWrapper = styled.div`
  background-color: #ffffff;

  .sticky-search-header {
    /* !important ensures no parent styles make it transparent */
    background-color: #ffffff !important; 
    display: flex;
    align-items: center;
    padding: 16px 24px;
    border-bottom: 1px solid #e0e0e0;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    /* This negative margin pulls it to the edges if the parent has padding */
    margin-bottom: 24px;
  }

  /* This fixes the 'DataGrid leaking' issue on other pages 
     by only allowing overflow: visible here */
  .sc--cardhead--details {
    overflow: visible !important;
  }
`;
const OrderPicklistPage = () => {
  const dispatch = useDispatch();
  const params = new URLSearchParams(window.location.search) // id=123
  let orderidfromurl = params.get('orderid')
  const orderpicklist = useSelector(
    (state) => state.orderpicklist && state.orderpicklist.orderpickdetailitems
  );
  const orderpicklistitems = useSelector((state) => state.orderpicklist);
  const orders = useSelector((state) => state.ordersNew);
  const profile = useSelector(state => state.auth);
  const ordersNotification = useSelector(state => state.ordersNew.createShipment);
  const [meta, setMeta] = useState(orders.ordersData.meta);
  const [orderId, setOrderId] = useState("");
  const [sku, setSku] = useState("");
  const [printUrl, setPrintUrl] = useState("");
  const [isPrinted, setIsPrinted] = useState(true);
  const [alert, setAlert] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalopen, setmodalopen] = useState(false) 
  const [yetpackedcount, setyetpackedcount] = useState(0)
  const [packedcount, setpackedcount] = useState(0)
  const [pageLoad, setpageLoad] = useState(false);
  const [orderSubmit, setorderSubmit] = useState(false);
  const [newOrderCreateDrawerVisible, setNewOrderCreateDrawerVisible] = useState(false);
  const [newOrderFormData, setNewOrderFormData] = useState("");
  const [isShipmentCreationFlow, setIsShipmentCreationFlow] = useState(false);
  const [isLabelButtonDisable, setIsLabelButtonDisable] = useState(false);
  const [isRateAutoEnabled, setIsRateAutoEnabled]= useState(false)
  const [isReturnOrder, setIsReturnOrder] = useState(false);
  const [isBarcodeEnabled, setIsBarcodeEnabled] = useState(false);
  const [scanError, setScanError] = useState("");
  const [filterTab, setFilterTab] = useState("all"); // "all" | "packed" | "unpacked"
  const skuInputRef = React.useRef(null);
  const [showAllLocations, setShowAllLocations] = useState(false);
  const assignedStoreName = profile?.profile?.assigned_store_id || "";
  // --- INSIDE YOUR COMPONENT ---
  const [syncLoading, setSyncLoading] = useState(false);
  const [syncAlert, setSyncAlert] = useState({ show: false, type: 'info', message: '' });

  const handlePicklistOrderRefresh = async () => {
      setSyncLoading(false); // Reset tracking references
      setSyncLoading(true);
      setSyncAlert({ show: false, type: 'info', message: '' });

      try {
          const baseUrl = process.env.REACT_APP_INTEGRATIONS_URL || 'http://localhost:7000';
          const userId = profile?.profile?.id;
          
          // Target dynamic references from your picklist details object mapping
          const pickData = orderpicklistitems?.orderpickdetail?.data;
          
          const payload = {
              userid: userId,
              shop: pickData?.store?.id,
              shopify_orderid: String(pickData?.order?.custom_fields?.order_id || '')
          };

          const response = await axios.post(`${baseUrl}/shopify/order-refresh`, payload, {
              headers: { 'Content-Type': 'application/json' }
          });

          if (response.status === 200 || response.data?.status === 'success') {
              setSyncAlert({
                  show: true,
                  type: 'success',
                  message: response.data?.message || 'Order resynced successfully from Shopify!'
              });
              // Optional: Dispatch a reload step here if needed to refresh the picklist view
          } else {
              setSyncAlert({
                  show: true,
                  type: 'error',
                  message: response.data?.message || 'Resync encountered a mismatch state.'
              });
          }
      } catch (error) {
          console.error("Picklist Sync Failure:", error);
          setSyncAlert({
              show: true,
              type: 'error',
              message: error.response?.data?.message || 'Network error executing picklist sync.'
          });
      } finally {
          setSyncLoading(false);
      }
  };

  // Evaluate platform criteria explicitly matching 'shopify' string values
  const isShopifyPlatform = String(orderpicklistitems?.orderpickdetail?.data?.platform || '').toLowerCase() === 'shopify';
  // const newOrderCreateCallback = (item,value) => {
  //   let finaldata={}
  //   Object.entries(initialData).map((entry) => {
  //     entry.map((item) => {
  //       if (item.title == "YET to be packed") {
  //         for (var key in item.items) {
  //           let current_item = item.items[key];
  //           finaldata=current_item
  //       } 
  //     }
  //   });
  //   });
  //   if(Object.keys(finaldata).length>0 && value=='check'){
  //     setmodalopen(true)
  //   }else{
  //     setIsShipmentCreationFlow(true);
  //     setNewOrderFormData(item);
  //     setNewOrderCreateDrawerVisible(true);
  //     setmodalopen(false)
  //   }
  // };

  // Add this helper to check for partial packing
  const getPackingStatus = () => {
    const unpacked = columns.yet_packed.items;
    const packed = columns.packed.items;

    // Find SKUs that exist in BOTH lists (Partial Packing)
    const partiallyPackedSKUs = unpacked.filter(u => 
      packed.some(p => p.sku === u.sku)
    ).map(i => i.sku);

    return {
      isFullyPacked: unpacked.length === 0,
      partiallyPackedSKUs,
      hasUnpackedItems: unpacked.length > 0
    };
  };

  const newOrderCreateCallback = (item, value) => {
      const unpackedItems = columns.yet_packed.items;
      const packedItems = columns.packed.items;
      const assignedStoreId = profile?.profile?.assigned_store_id;

      // 1. Separate "My Store" items from "Other Store" items
      // If assignedStoreId is empty, we treat all items as "My Store"
      const myStoreUnpacked = assignedStoreId 
          ? unpackedItems.filter(i => String(i.location?.id) === String(assignedStoreId))
          : unpackedItems;

      const myStorePacked = assignedStoreId
          ? packedItems.filter(i => String(i.location?.id) === String(assignedStoreId))
          : packedItems;

      // 2. BLOCK LOGIC: Check for partial packing WITHIN My Store only
      const packedIDSet = new Set(myStorePacked.map(p => String(p.line_item_id)));
      const partiallyPackedItem = myStoreUnpacked.find(u => packedIDSet.has(String(u.line_item_id)));

      if (partiallyPackedItem) {
          const skuName = partiallyPackedItem.sku || "Selected Item";
          setScanError(`The SKU ${skuName} still has units pending in your store. Please complete packing to proceed.`);
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return; // HARD BLOCK
      }

      // 3. VALIDATION LOGIC:
      const isMyStoreIncomplete = myStoreUnpacked.length > 0;
      const areOtherStoresPending = unpackedItems.some(i => String(i.location?.id) !== String(assignedStoreId));

      if (isMyStoreIncomplete) {
          // Scenario A: User hasn't finished their own store's items
          setmodalopen(true); // Warning: "You have unpacked items..."
      } 
      else if (areOtherStoresPending) {
          // Scenario B: User finished their store, but other stores are still pending
          // We still show the modal to inform them that the order isn't globally finished
          setmodalopen(true); 
      } 
      else {
          // Scenario C: Everything (All stores) is packed
          newOrderCreateCallbackProceed(item);
      }
  };
  const newOrderCreateCallbackProceed = (item) => {
      setIsShipmentCreationFlow(true);
      setNewOrderFormData(item);
      setNewOrderCreateDrawerVisible(true);
      setmodalopen(false)
  };

  const newOrderCreateOnClose = () => {
    setNewOrderCreateDrawerVisible(false);
  };

  const handleClose = () => {
    setOpen(false);
    dispatch(resetOrderPickNotification())
    setScanError("")
  };

  const handleSubmit = () => {
    setorderSubmit(true)
    setScanError("");
    setIsLabelButtonDisable(false)
    dispatch(fetchPickOrderDetail(orderId));
    dispatch(fetchPickOrderDetailitems(orderId));
  };

  const handleScanSubmit = () => {
      setorderSubmit(true);
      setScanError("");
      const scanValue = sku.trim();
      if (!scanValue) return;

      const assignedStoreId = profile?.profile?.assigned_store_id;
      let sourceItems = [...columns.yet_packed.items];
      let destItems = [...columns.packed.items];

      // 1. Find ONLY the first unique item card matching the barcode/sku
      const itemIndex = sourceItems.findIndex((item) =>
          isBarcodeEnabled ? item.barcode === scanValue : item.sku === scanValue
      );

      if (itemIndex > -1) {
          const targetItem = sourceItems[itemIndex];

          // --- NEW STORE VALIDATION CONDITION ---
          // If user has an assigned store, check if the item belongs to it
          if (assignedStoreId && String(targetItem.location?.id) !== String(assignedStoreId)) {
              setScanError(`Restricted: This item belongs to ${targetItem.location?.name || 'another store'}. You can only pack items for your assigned store.`);
              setSku("");
              return; // Stop execution here
          }

          // 2. Move only THIS specific unique item locally
          const [movedItem] = sourceItems.splice(itemIndex, 1);
          const updatedMovedItem = { ...movedItem, is_packed: true };
          destItems.push(updatedMovedItem);

          // 3. Update local UI State (Visually moves 1 card)
          setColumns({
              yet_packed: { ...columns.yet_packed, items: sourceItems },
              packed: { ...columns.packed, items: destItems },
          });

          // 4. SERVER SYNC: Only fire if NO MORE cards of this SKU exist in 'Yet Packed'
          const remainingOfThisSku = sourceItems.filter(i => 
              isBarcodeEnabled ? i.barcode === scanValue : i.sku === scanValue
          );

          if (remainingOfThisSku.length === 0) {
              const allPackedUnits = destItems.filter(i => 
                  isBarcodeEnabled ? i.barcode === scanValue : i.sku === scanValue
              );

              dispatch(putOrderItemsDetails(profile.profile.id, {
                  items: allPackedUnits,
                  packed: true,
                  doc_id: orderpicklist?.data?.doc_id,
                  order_id: orderpicklist?.data?.order_id,
              }, orderpicklist?.data?.order_id));
          }
          setSku("");
      } else {
          setScanError(`SKU ${scanValue} not found or already packed.`);
          setSku("");
      }
  };
//  const handleScanSubmit = () => {
//     setorderSubmit(true);
//     setScanError(""); 
    
//     const assignedStoreName = profile?.profile?.assigned_store_id;
//     const scanValue = sku.trim();

//     if (!scanValue) return;

//     // 1. Check if already in 'Packed' column
//     const isAlreadyPacked = columns.packed?.items?.some(item => 
//       isBarcodeEnabled ? item.barcode === scanValue : item.sku === scanValue
//     );

//     if (isAlreadyPacked) {
//       setScanError(`Duplicate: ${scanValue} is already packed.`);
//       setSku("");
//       return;
//     }

//     // 2. Search for the item across BOTH columns to see if it exists at all
//     const allItems = [
//       ...(columns.yet_packed?.items || []),
//       ...(columns.packed?.items || [])
//     ];

//     const itemExistsInOrder = allItems.find(item => 
//       isBarcodeEnabled ? item.barcode === scanValue : item.sku === scanValue
//     );

//     if (itemExistsInOrder) {
//       // 3. If item exists, check for Store Location Permission
//       if (assignedStoreName && assignedStoreName !== "" && itemExistsInOrder.location?.id !== assignedStoreName) {
//         setScanError(`Restricted: This item belongs to ${itemExistsInOrder.location?.id || 'another store'}.`);
//         setSku("");
//         return;
//       }

//       // 4. Success: Item exists and user has permission
//       const finaldata = {
//         items: [itemExistsInOrder],
//         packed: true,
//         doc_id: orderpicklist?.data?.doc_id,
//         order_id: orderpicklist?.data?.order_id,
//       };

//       dispatch(putOrderItemsDetails(profile.profile.id, finaldata, orderpicklist?.data?.order_id));
//     } else {
//       // 5. Item does not exist in this order at all
//       setScanError(`Not Found: ${scanValue} was not found in the current order.`);
//     }

//     setSku(""); 
//   };

  const movePacked = () => {
      const assignedStoreName = profile?.profile?.assigned_store_id;
      setorderSubmit(true);
      setScanError("");

      let doc_id = orderpicklist?.data?.doc_id;
      let order_id = orderpicklist?.data?.order_id;

      let currentYetPacked = [...columns.yet_packed.items];
      let currentPacked = [...columns.packed.items];
      
      // 1. Identify which items to move based on store permission
      const itemsToMove = currentYetPacked.filter(item => 
          !assignedStoreName || assignedStoreName === "" || item.location?.id === assignedStoreName
      );

      if (itemsToMove.length === 0) {
          setScanError("No items for your location are available to pack.");
          return;
      }

      // 2. Update Local State Visually First
      const remainingYetPacked = currentYetPacked.filter(item => 
          assignedStoreName && assignedStoreName !== "" && item.location?.id !== assignedStoreName
      );
      const newPackedList = [...currentPacked, ...itemsToMove.map(i => ({ ...i, is_packed: true }))];

      setColumns({
          ...columns,
          yet_packed: { ...columns.yet_packed, items: remainingYetPacked },
          packed: { ...columns.packed, items: newPackedList }
      });

      // 3. SERVER SYNC LOGIC: Group by line_item_id
      // Only send items to server if ALL units of that line_item_id are now in the 'Packed' list
      const completedItemsForServer = itemsToMove.filter(movedItem => {
          const isStillInYetPacked = remainingYetPacked.some(remain => 
              String(remain.line_item_id) === String(movedItem.line_item_id)
          );
          return !isStillInYetPacked; // If not in yet_packed anymore, it's complete
      });

      if (completedItemsForServer.length > 0) {
          const finaldata = {
              doc_id: doc_id,
              order_id: order_id,
              packed: true,
              items: completedItemsForServer,
          };
          dispatch(putOrderItemsDetails(profile.profile.id, finaldata, order_id));
      }
  };

  const moveYetPacked = () => {
    const assignedStoreName = profile?.profile?.assigned_store_id;
    setorderSubmit(true);
    setScanError("");

    let doc_id = orderpicklist?.data?.doc_id;
    let order_id = orderpicklist?.data?.order_id;

    let currentPacked = [...columns.packed.items];
    let currentYetPacked = [...columns.yet_packed.items];

    // 1. Identify items belonging to user's store in the Packed column
    const itemsToMoveBack = currentPacked.filter(item => 
        !assignedStoreName || assignedStoreName === "" || item.location?.id === assignedStoreName
    );

    if (itemsToMoveBack.length === 0) {
        setScanError("No packed items for your location to move back.");
        return;
    }

    // 2. Update Local State Visually
    const remainingPacked = currentPacked.filter(item => 
        assignedStoreName && assignedStoreName !== "" && item.location?.id !== assignedStoreName
    );
    const newYetPackedList = [...currentYetPacked, ...itemsToMoveBack.map(i => ({ ...i, is_packed: false }))];

    setColumns({
        ...columns,
        yet_packed: { ...columns.yet_packed, items: newYetPackedList },
        packed: { ...columns.packed, items: remainingPacked }
    });

    // 3. SERVER SYNC: Unpack items immediately
    // We send the request once for all items being moved back
    const finaldata = {
        doc_id: doc_id,
        order_id: order_id,
        packed: false,
        items: itemsToMoveBack,
    };

    dispatch(putOrderItemsDetails(profile.profile.id, finaldata, order_id));
};

  const openLabelClick = (item) => {
    let labels = []
    if (item &&
      item.shipment &&
      item.shipment.tracking &&
      item.shipment.tracking.length != 0) {
        for (var key of Object.keys(item.shipment.tracking)) {
            let dataTemp = typeof item.shipment.tracking[key] == "object" ? JSON.parse(JSON.stringify(item.shipment.tracking[key])) : {}
         if (item.shipment.tracking[key] &&
                item.shipment.tracking[key].label &&
                item.shipment.tracking[key].label.url &&
                item.shipment.tracking[key].label.url != "") {
                if (!labels.includes(item.shipment.tracking[key].label.url)) {
                    labels.push(item.shipment.tracking[key].label.url)
                }
            }
        }
    }
    if (labels.length == 1) {
        setPrintUrl(labels[0])
        setIsPrinted(false)
    }
}

  const onInputClear = () => {
    setOrderId("");
    setScanError("")
    setSku(""); 
    setorderSubmit(false)
    dispatch(resetOrderPickNotification())
    setColumns({
      yet_packed: {
        title: "YET to be packed",
        items: [],
      },
      packed: {
        title: "Packed",
        items: [],
      },
    })
    setyetpackedcount(0)
    setpackedcount(0)
  };
  const columns1 = [
    // {
    //   field: "Store order ID",
    //   headerName: "Store order ID",
    //   sortable: false,
    //   minWidth:200,
    //   renderCell: (params) => {
    //     if (orderpicklistitems &&
    //       orderpicklistitems.orderpickdetail &&
    //       orderpicklistitems.orderpickdetail.data &&
    //       orderpicklistitems.orderpickdetail.data.order && 
    //       orderpicklistitems.orderpickdetail.data.order.custom_fields &&
    //       orderpicklistitems.orderpickdetail.data.order.custom_fields.store_order_id) {
    //         let order_id = orderpicklistitems.orderpickdetail.data.order.custom_fields.store_order_id;
    //         return order_id.replace("CA", "").replace("US", "").replace("GB", "");
    //     } else {
    //       return "-";
    //     }
    //   },
    // },
    ...(isBarcodeEnabled ? [{
      field: "name",
      headerName: "Assigned Store",
      sortable: false,
      minWidth: 300,
      renderCell: (params) => {
        const location = params.row.location;
        
        if (location && location.name) {
          // This will display: "Toronto Premium Outlets (72565391556)"
          return `${location.name} (${location.id})`;
        }
        
        return "-";
      },
    }] : []),
    {
      field: "quantity",
      headerName: "Packing Status",
      sortable: false,
      minWidth: 180,
      align: "center",       // Centers the cell content horizontally
      headerAlign: "center", // Centers the column header text
      renderCell: (params) => {
        const lineItemId = String(params.row.line_item_id);
        const totalQty = parseInt(params.row.quantity) || 0;

        // Count units currently in 'Packed' column
        const currentlyPacked = columns.packed.items.filter(
          (item) => String(item.line_item_id) === lineItemId
        ).length;

        const isComplete = currentlyPacked === totalQty;
        const isStarted = currentlyPacked > 0;

        return (
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', // Centers children inside the Box
              gap: 1.5, 
              width: '100%',
              height: '100%' 
            }}
          >
            <Typography 
              variant="body2" 
              sx={{ 
                fontWeight: isStarted ? 700 : 400,
                minWidth: '45px', // Prevents layout jump when numbers change
                textAlign: 'right'
              }}
            >
              {currentlyPacked} / {totalQty}
            </Typography>
            
            {/* Progress Bar Container */}
            <Box 
              sx={{ 
                width: 50, 
                height: 6, 
                bgcolor: '#f0f0f0', 
                borderRadius: 3, 
                overflow: 'hidden',
                border: '1px solid #e0e0e0'
              }}
            >
              <Box 
                sx={{ 
                  width: `${(currentlyPacked / totalQty) * 100}%`, 
                  height: '100%', 
                  bgcolor: isComplete ? '#2e7d32' : (isStarted ? '#ed6c02' : '#bdbdbd'),
                  transition: 'width 0.3s ease'
                }} 
              />
            </Box>

            <Box sx={{ width: 20, display: 'flex', justifyContent: 'center' }}>
                {isComplete ? (
                    <CheckCircleIcon sx={{ fontSize: 18, color: '#2e7d32' }} />
                ) : (
                    isStarted && <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#ed6c02' }} />
                )}
            </Box>
          </Box>
        );
      },
    },
    {
      field: "product_id",
      headerName: "Product Id",
      sortable: false,
      minWidth:300,
      renderCell: (params) => {
        if (params.row.product_id && typeof params.row.product_id !== "undefined") {
          return params.row.product_id;
        } else {
          return "-";
        }
      },
    },
    
    {
      field: "product_desc",
      headerName: "Product Desc",
      sortable: false,
      minWidth:300,
      renderCell: (params) => {
        if (
          params.row.product_desc &&
          typeof params.row.product_desc !== "undefined"
        ) {
          return (
                  <Tooltip
                        title={params.row.product_desc}
                        placement="top"
                      >
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                      {params.row.product_desc}
                    </span>
                  </Tooltip>
          );
        } else {
          return "-";
        }
      },
    },
    {
  field: "sku",
  headerName: "SKU",
  sortable: false,
  minWidth: 250,
  renderCell: (params) => {
    const assignedStoreName = profile?.profile?.assigned_store_id;
    const isMismatch = assignedStoreName && assignedStoreName !== "" && params.row.location?.id !== assignedStoreName;
    const isPacked = params.row.is_packed === true;

    const handleCopyAction = (e, value) => {
      e.stopPropagation();
      if (isPacked) return; 

      // 1. Copy to Clipboard
      navigator.clipboard.writeText(value);
      
      // 2. SMART PASTE: Update the state so it appears in the input box immediately
      setSku(value);
      setScanError("");

      // 3. AUTO-FOCUS: Jump to search box
      if (skuInputRef.current) {
        skuInputRef.current.focus();
        // Since we populated the value, we select it for easy overwriting if needed
        skuInputRef.current.select(); 
      }
    };

    return (
        <div 
          onClick={(e) => {
            const valueToCopy = isBarcodeEnabled ? params.row.barcode : params.row.sku;
            handleCopyAction(e, valueToCopy);
          }}
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px', 
            cursor: isPacked ? 'default' : 'copy'
          }}
        >
          {/* Tooltip removed as requested */}
          {/* {!isBarcodeEnabled && ( 
              isPacked ? <CheckCircleIcon style={{ color: '#2e7d32', fontSize: '18px' }} /> : <CancelIcon style={{ color: '#d32f2f', fontSize: '18px' }} />
          )} */}

          <span style={{ 
            fontWeight: isMismatch ? 'bold' : '500', 
            color: isPacked ? 'inherit' : '#1976d2', 
            borderBottom: isPacked ? 'none' : '1px dashed #1976d2'
          }}>
            {params.row.sku || "-"}
          </span>

          {!isBarcodeEnabled && !isPacked && (
            <ContentCopyIcon 
              style={{ fontSize: '14px', color: '#9e9e9e', opacity: 0.6 }} 
            />
          )}

          {!isBarcodeEnabled && isMismatch && (
            <Tooltip title={`Warning: Item belongs to ${params.row.location?.name || "another store"}`} arrow>
              <WarningAmberIcon style={{ color: '#ed6c02', fontSize: '18px', cursor: 'help' }} />
            </Tooltip>
          )}
        </div>
    );
  },
},
...(isBarcodeEnabled ? [{
  field: "barcode",
  headerName: "Barcode",
  sortable: false,
  minWidth: 200,
  renderCell: (params) => {
    const assignedStoreName = profile?.profile?.assigned_store_id;
    const isMismatch = assignedStoreName && assignedStoreName !== "" && params.row.location?.id !== assignedStoreName;
    const isPacked = params.row.is_packed === true;

    const handleCopyAction = (e, value) => {
      e.stopPropagation();
      if (isPacked) return;

      navigator.clipboard.writeText(value);
      
      // Smart Paste
      setSku(value);
      setScanError("");

      if (skuInputRef.current) {
        skuInputRef.current.focus();
        skuInputRef.current.select(); 
      }
    };

    return (
        <div 
          onClick={(e) => handleCopyAction(e, params.row.barcode)}
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px', 
            cursor: isPacked ? 'default' : 'copy',
            width: '100%'
          }}
        >
          {/* {isPacked ? <CheckCircleIcon style={{ color: '#2e7d32', fontSize: '18px' }} /> : <CancelIcon style={{ color: '#d32f2f', fontSize: '18px' }} />} */}
          
          <span style={{ 
            fontWeight: isMismatch ? 'bold' : '500', 
            color: isPacked ? 'inherit' : '#1976d2',
            borderBottom: isPacked ? 'none' : '1px dashed #1976d2' 
          }}>
            {params.row.barcode || "-"}
          </span>

          {!isPacked && (
            <ContentCopyIcon 
              style={{ fontSize: '14px', color: '#9e9e9e', opacity: 0.6 }} 
            />
          )}

          {isMismatch && (
            <Tooltip title={`Warning: Item belongs to ${params.row.location?.name || "another store"}`} arrow>
              <WarningAmberIcon style={{ color: '#ed6c02', fontSize: '18px', cursor: 'help' }} />
            </Tooltip>
          )}
        </div>
    );
  },
}] : []),
    
    {
      field: "product_price",
      headerName: "Product Price",
      sortable: false,
      minWidth:150,
      renderCell: (params) => {
        if (params.row.product_price && typeof params.row.product_price !== "undefined") {
          return params.row.product_price;
        } else {
          return "-";
        }
      },
    },
  ];

  const [columns, setColumns] = useState({
    yet_packed: {
      title: "YET to be packed",
      items: [],
    },
    packed: {
      title: "Packed",
      items: [],
    },
  });

  const [initialData, setInitialData] = useState({
    yet_packed: {
      title: "YET to be packed",
      items: [],
    },
    packed: {
      title: "Packed",
      items: [],
    },
  });

  const unitCounts = useMemo(() => {
    const yetUnits = columns.yet_packed.items.reduce((acc, item) => acc + (parseInt(item.quantity) || 0), 0);
    const packedUnits = columns.packed.items.reduce((acc, item) => acc + (parseInt(item.quantity) || 0), 0);
    return { yetUnits, packedUnits };
  }, [columns]);

  const onDragEnd = (result, columns, setColumns) => {
      if (!result.destination) return;
      const { source, destination } = result;

      if (source.droppableId !== destination.droppableId) {
          setorderSubmit(true);
          
          let sourceColumn = columns[source.droppableId];
          let destColumn = columns[destination.droppableId];
          let sourceItems = [...sourceColumn.items];
          let destItems = [...destColumn.items];

          let [removedItem] = sourceItems.splice(source.index, 1);
          const isMovingToPacked = destination.droppableId === "packed";
          removedItem = { ...removedItem, is_packed: isMovingToPacked };

          destItems.splice(destination.index, 0, removedItem);

          // 1. Update Local UI State IMMEDIATELY
          setColumns({
              ...columns,
              [source.droppableId]: { ...sourceColumn, items: sourceItems },
              [destination.droppableId]: { ...destColumn, items: destItems },
          });

          // 2. SERVER SYNC LOGIC
          if (isMovingToPacked) {
              // --- YET PACKED -> PACKED ---
              // Only sync when the LAST unit of this ID moves to Packed
              const remainingInSource = sourceItems.filter(
                  item => String(item.line_item_id) === String(removedItem.line_item_id)
              );

              if (remainingInSource.length === 0) {
                  const allUnitsOfThisId = destItems.filter(
                      item => String(item.line_item_id) === String(removedItem.line_item_id)
                  );

                  const finaldata = {
                      items: allUnitsOfThisId,
                      packed: true,
                      doc_id: orderpicklist?.data?.doc_id,
                      order_id: orderpicklist?.data?.order_id,
                  };
                  dispatch(putOrderItemsDetails(profile.profile.id, finaldata, orderpicklist?.data?.order_id));
              }
          } else {
              // --- PACKED -> YET PACKED ---
              // Only sync when the FIRST unit of this ID moves back to Yet Packed
              // We check the destination (Yet Packed) BEFORE we added the item.
              // But since we already updated state above, we check if there is EXACTLY 1 unit now.
              
              const countInYetPacked = destItems.filter(
                  item => String(item.line_item_id) === String(removedItem.line_item_id)
              ).length;

              if (countInYetPacked === 1) {
                  // This is the first unit of this SKU moving back. 
                  // Inform server that this Line Item is no longer fully packed.
                  const finaldata = {
                      items: [removedItem],
                      packed: false,
                      doc_id: orderpicklist?.data?.doc_id,
                      order_id: orderpicklist?.data?.order_id,
                  };
                  dispatch(putOrderItemsDetails(profile.profile.id, finaldata, orderpicklist?.data?.order_id));
              } else {
                  console.log("SKU already marked as unpacked on server. Skipping redundant request.");
              }
          }
      } else {
          // Handle re-ordering within same column
          const column = columns[source.droppableId];
          const copiedItems = [...column.items];
          const [removed] = copiedItems.splice(source.index, 1);
          copiedItems.splice(destination.index, 0, removed);
          setColumns({
              ...columns,
              [source.droppableId]: { ...column, items: copiedItems },
          });
      }
  };

  useEffect(() => {
    const data = orderpicklistitems?.orderpickdetailitems?.data;
    const assignedStoreName = profile?.profile?.assigned_store_id;

    if (data && Object.keys(data).length !== 0) {
      let unpackedItems = data.unpacked_items || [];
      let packedItems = data.packed_items || [];

      // --- UPDATED FILTERING LOGIC ---
      // Only filter by store if "Show All Locations" is FALSE
      if (!showAllLocations && assignedStoreName && assignedStoreName !== "") {
        unpackedItems = unpackedItems.filter(
          (item) => item.location?.id === assignedStoreName
        );
        packedItems = packedItems.filter(
          (item) => item.location?.id === assignedStoreName
        );
      }

      setColumns({
        yet_packed: { title: "YET to be packed", items: unpackedItems },
        packed: { title: "Packed", items: packedItems },
      });

      setInitialData({
        yet_packed: { title: "YET to be packed", items: unpackedItems },
        packed: { title: "Packed", items: packedItems },
      });

      setyetpackedcount(unpackedItems.length);
      setpackedcount(packedItems.length);
    }
  }, [orderpicklistitems.orderpickdetailitems.data, showAllLocations]); // Add showAllLocations as dependency
  useEffect(() => {
    if(orderpicklistitems && orderpicklistitems.orderpickdetail && orderpicklistitems.orderpickdetail.notification && orderpicklistitems.orderpickdetail.notification.messageType=='error'){
      setColumns({
        yet_packed: {
          title: "YET to be packed",
          items: [],
        },
        packed: {
          title: "Packed",
          items: [],
        },
      }) 
      setyetpackedcount(0);
      setpackedcount(0);
      setAlert(true)
      setOpen(true)
    }else{
      setAlert(false)
      setOpen(false)
    }

  },[orderpicklistitems.orderpickdetail])

  useEffect(() => {
    if (orderidfromurl !== "" && orderidfromurl!=null && orderidfromurl!=undefined) {
      setOrderId(orderidfromurl);
      dispatch(fetchPickOrderDetail(orderidfromurl));
      dispatch(fetchPickOrderDetailitems(orderidfromurl));
    }
  }, [orderidfromurl]);

  useEffect(() => {
    if (orderId=='' && pageLoad==false) {
        dispatch(resetOrderPickNotification())
        setColumns({
          yet_packed: {
            title: "YET to be packed",
            items: [],
          },
          packed: {
            title: "Packed",
            items: [],
          },
        })
        setyetpackedcount(0)
        setpackedcount(0)
        setpageLoad(true)
       
    }
  }, [orderpicklistitems]);

  useEffect(() => {
    if (ordersNotification && ordersNotification.notification && ordersNotification.notification.messageContent
        && ordersNotification.notification.messageContent[0] === 'Shipment Created Successfully') {
          // dispatch(fetchPickOrderDetail(orderpicklist &&
          //   orderpicklist.data &&
          //   orderpicklist.data.order_id));
          setOrderId("");
          setColumns({
            yet_packed: { title: "YET to be packed", items: [] },
            packed: { title: "Packed", items: [] },
          });
          setyetpackedcount(0);
          setpackedcount(0);
          setInitialData({
            yet_packed: { title: "YET to be packed", items: [] },
            packed: { title: "Packed", items: [] },
          });
          setorderSubmit(false)
          setIsLabelButtonDisable(true)
          dispatch(resetOrderPickNotification())
        }
  }, [ordersNotification]);
  
  useEffect(() => {
    if (profile && profile.profile) {
      if (profile.profile.auto_fetch_rate === true) setIsRateAutoEnabled(true);
      // New flag check
      if (profile.profile.use_barcode_for_picklist_scan === true) setIsBarcodeEnabled(true);
    }
  }, [profile]);   
  
  useEffect(() => {
    const updateState = orderpicklistitems?.orderpickdetailitemsupdate;
    if (updateState?.notification?.show && updateState?.notification?.messageType === 'success') {
      const currentOrderId = orderpicklist?.data?.order_id;
      if (currentOrderId) {
        // 1. Refresh data
        dispatch(fetchPickOrderDetail(currentOrderId));
        // 2. IMMEDIATELY clear the notification to prevent the loop
        dispatch(clearPicklistItemOrderNotification());
      }
    }
}, [orderpicklistitems?.orderpickdetailitemsupdate?.notification?.show]); 

  // Check if the user has at least one item they are allowed to move TO packed
  const canMoveToPacked = useMemo(() => {
    const assignedStoreName = profile?.profile?.assigned_store_id;
    const items = columns.yet_packed?.items || [];
    
    // If no store restriction, enable. If restricted, check if any item matches the name.
    if (!assignedStoreName) return items.length > 0;
    return items.some(item => item.location?.id === assignedStoreName);
  }, [columns.yet_packed, profile?.profile?.assigned_store_id]);

  // Check if the user has at least one item they are allowed to move BACK to yet-packed
  const canMoveToYetPacked = useMemo(() => {
    const assignedStoreName = profile?.profile?.assigned_store_id;
    const items = columns.packed?.items || [];
    
    if (!assignedStoreName) return items.length > 0;
    return items.some(item => item.location?.id === assignedStoreName);
  }, [columns.packed, profile?.profile?.assigned_store_id]);

  // 1. Filter raw data based ONLY on the Store toggle
  const storeFilteredData = useMemo(() => {
    let allRows = orderpicklistitems?.orderpickdetail?.data?.line_items || [];
    const assignedStore = profile?.profile?.assigned_store_id || "";
    console.log(assignedStore)
    if (!showAllLocations && assignedStore !== "") {
      return allRows.filter(row => row.location?.id === assignedStore);
    }
    return allRows;
  }, [orderpicklistitems?.orderpickdetail?.data?.line_items, showAllLocations, profile?.profile?.assigned_store_id]);

  // 2. Derive the actual rows for the DataGrid based on the active Tab
  const filteredRows = useMemo(() => {
    let rows = [];
    if (filterTab === "all") return storeFilteredData;
    if (filterTab === "packed") return storeFilteredData.filter(row => row.is_packed === true);
    if (filterTab === "unpacked") return storeFilteredData.filter(row => row.is_packed !== true);
    // We return a new array reference so DataGrid knows to re-render the cells 
    // even if the Redux data hasn't changed yet, but the local 'columns' has.
    return [...rows];
  }, [storeFilteredData, filterTab, columns]);

  // 3. Calculate unpacked count for the color logic
  const currentUnpackedCount = useMemo(() => {
    const hasUnpackedItems = storeFilteredData.some(row => row.is_packed !== true);
    if (hasUnpackedItems) {
      setFilterTab("unpacked");
    }
    return storeFilteredData.filter(r => !r.is_packed).length;
  }, [storeFilteredData]);

  // useEffect(() => {
  //   let timer;
  //   if (scanError) {
  //     timer = setTimeout(() => {
  //       setScanError("");
  //     }, 5000); // 5000ms = 5 seconds
  //   }
  //   return () => clearTimeout(timer); // Cleanup timer if component unmounts or error changes
  // }, [scanError]);

  const packingProgress = useMemo(() => {
      const total = yetpackedcount + packedcount;
      if (total === 0) return 0;
      return Math.round((packedcount / total) * 100);
    }, [yetpackedcount, packedcount]);

  const otherStoreItemsCount = useMemo(() => {
    const allRows = orderpicklistitems?.orderpickdetail?.data?.line_items || [];
    const assignedStoreName = profile?.profile?.assigned_store_id;

    // Count items that are NOT packed AND belong to a DIFFERENT store
    return allRows.filter(row => 
      !row.is_packed && 
      assignedStoreName && 
      row.location?.id !== assignedStoreName
    ).length;
  }, [orderpicklistitems?.orderpickdetail?.data?.line_items, profile?.profile?.assigned_store_id]);
  return (
    <>

      {orders &&
        orders.createShipment.notification &&
        orders.createShipment.notification.show && (
          <Notification
            is_open={orders.createShipment.notification.show}
            messageType={orders.createShipment.notification.messageType}
            messages={orders.createShipment.notification.messageContent}
            handleClose={() => {
              dispatch(resetOrderNotifications());
              setScanError(""); // Clear local scan errors
            }}
          />
        )}     

       {orderpicklistitems &&
        orderpicklistitems.orderpickdetailitemsupdate &&
        orderpicklistitems.orderpickdetailitemsupdate.notification &&
        orderpicklistitems.orderpickdetailitemsupdate.notification.show && (
          <Notification
            is_open={orderpicklistitems.orderpickdetailitemsupdate.notification.show}
            messageType={orderpicklistitems.orderpickdetailitemsupdate.notification.messageType}
            messages={orderpicklistitems.orderpickdetailitemsupdate.notification.messageContent}
            handleClose={() => {
              dispatch(clearPicklistItemOrderNotification());
              setScanError(""); // Clear local scan errors
            }}
          />
        )}  
        
      {alert && (
        <Snackbar
          open={open}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            severity={"error"}
            style={{ justifyContent: "center", margin: "10px 0" }}
          >
            <span> {orderpicklistitems.orderpickdetail.notification.messageContent.message}</span>
          </Alert>
        </Snackbar>
      )}
      <div>
         <Modal
            open={modalopen}
            aria-labelledby="manifest-confirm-modal-title"
            aria-describedby="manifest-confirm-modal-description"
        >
            <Box sx={style}>
                <Typography style={{ textAlign: "center" }} id="manifest-confirm-modal-description" sx={{ mt: 2 }}>
                You have some unpacked items for this order. <br />Still do you want to proceed?
                </Typography>
              <Typography style={{ marginTop: "30px", textAlign: "center" }}>
                    <Button variant="contained"  onClick={()=>newOrderCreateCallbackProceed(orderpicklistitems.orderpickdetail.data)}>Yes</Button>
                    <Button variant="outlined" style={{ marginLeft: "15px" }} onClick={() => { setmodalopen(false) }}>No</Button>
                </Typography>
            </Box>
        </Modal>
        </div>
        <PicklistPageWrapper className="order-picklist-container">
          <Box sx={{ width: '100%' }}>
            {/* ─── DYNAMIC RESYNC DISMISSABLE ALERT CHANNEL ─── */}
            <Collapse in={syncAlert.show}>
                <Alert 
                    severity={syncAlert.type} 
                    onClose={() => setSyncAlert(prev => ({ ...prev, show: false }))}
                    sx={{ mb: 2, borderRadius: '8px', fontWeight: 600 }}
                >
                    {syncAlert.message}
                </Alert>
            </Collapse>

            <Box 
                className="sticky-search-header" 
                sx={{ 
                    opacity: 1, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between', 
                    width: '100%' 
                }}
            >
                {/* 1. LEFT ELEMENT: Title (Flex-basis matches right side to force true center) */}
                <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: '#333', whiteSpace: 'nowrap' }}>
                        Picklist Verification
                    </Typography>
                </Box>

                {/* 2. MIDDLE ELEMENT: Search Bar (Perfectly Centered in Viewport) */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <TextField
                        placeholder="Scan or Type Order ID..."
                        size="small"
                        variant="outlined"
                        value={orderId}
                        onInput={(e) => {
                            setOrderId(e.target.value);
                            setorderSubmit(false);
                        }}
                        onKeyUp={(event) => { if (event.key === "Enter") handleSubmit(); }}
                        inputRef={(orderinput) => {
                            if (orderId === '' && orderSubmit === false) 
                                orderinput && orderinput.focus();
                        }}
                        InputProps={{
                            startAdornment: (
                                <IconButton size="small" sx={{ pointerEvents: 'none', mr: -0.5 }}>
                                    <AddCircleOutlineOutlinedIcon sx={{ fontSize: 18, color: '#999' }} />
                                </IconButton>
                            ),
                            endAdornment: orderId ? (
                                <IconButton size="small" onClick={() => onInputClear()}>
                                    <ClearIcon sx={{ fontSize: 16 }} />
                                </IconButton>
                            ) : undefined,
                        }}
                        sx={{ 
                            width: "350px",
                            '& .MuiOutlinedInput-root': {
                                backgroundColor: '#f9f9f9',
                                borderRadius: '6px',
                                '& fieldset': { borderColor: '#e0e0e0' },
                                fontSize: '13px'
                            }
                        }}
                    />
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={orderId === ""}
                        sx={{ 
                            height: '37px', 
                            px: 4, 
                            fontWeight: 'bold', 
                            borderRadius: '6px',
                            textTransform: 'none',
                            boxShadow: 'none'
                        }}
                    >
                        Search
                    </Button>
                </Box>

                {/* 3. RIGHT ELEMENT: Resync Action Button (Absolute Far Right Corner) */}
                <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                    {isShopifyPlatform ? (
                        <Button
                            variant="outlined"
                            onClick={handlePicklistOrderRefresh}
                            disabled={syncLoading}
                            startIcon={syncLoading ? <CircularProgress size={16} color="inherit" /> : <SyncIcon />}
                            sx={{
                                height: '37px',
                                px: 2.5,
                                fontWeight: 700,
                                borderRadius: '6px',
                                textTransform: 'none',
                                color: '#1976d2',
                                borderColor: '#E2E8F0',
                                backgroundColor: '#FFFFFF',
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                    borderColor: '#CBD5E1'
                                }
                            }}
                        >
                            {syncLoading ? 'Resyncing...' : 'Resync Order'}
                        </Button>
                    ) : (
                        /* Empty placeholder box matching the layout parameters if non-Shopify to retain perfect balance */
                        <Box sx={{ width: '135px', height: '37px' }} />
                    )}
                </Box>
            </Box>
        </Box>

        {orderpicklistitems &&
          orderpicklistitems.orderpickdetail &&
          orderpicklistitems.orderpickdetail.loading && <LinearProgress />}

        {orderpicklistitems &&
          orderpicklistitems.orderpickdetail &&
          orderpicklistitems.orderpickdetail.data &&
          orderpicklistitems.orderpickdetail.data &&
          orderpicklistitems.orderpickdetail.data.line_items &&
          orderpicklistitems.orderpickdetail.data.line_items.length != 0 && (
            <Card sx={{ marginTop: "20px" }} className="sc--cardhead--details">
              <div style={{ width: "100%", background: "#fff" }}>
                <CardHeader
                  title="Line Item Detail"
                  action={
                    <>
                      <Tooltip
                        title="Print package slip"
                        placement="left-start"
                      >
                        <Button variant="outlined">
                          <LocalPrintshopOutlinedIcon
                            style={{ color: "#1890ff", cursor: "pointer" }}
                            onClick={() => {
                              setPrintUrl(profile && profile.profile && profile.profile.label_size_packaging_slip && profile.profile.label_size_packaging_slip==true ? "https://integrations.shippingchimp.com/package-customslip-order?doc_id=" +
                              orderpicklistitems.orderpickdetail.data._id :
                                "https://integrations.shippingchimp.com/package-slip-order?doc_id=" +
                                  orderpicklistitems.orderpickdetail.data._id
                              );
                              setIsPrinted(false);
                            }}
                          />
                        </Button>
                      </Tooltip>
                    </>
                  }
                />
              </div>
              <Divider />
              <div style={{ padding: "10px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", gap: "10px" }}>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <Button 
                      variant={filterTab === "all" ? "contained" : "outlined"} 
                      onClick={() => setFilterTab("all")}
                      size="small"
                    >
                      All ({storeFilteredData.length})
                    </Button>
                    
                    <Button 
                      variant={filterTab === "packed" ? "contained" : "outlined"} 
                      color="success"
                      onClick={() => setFilterTab("packed")}
                      size="small"
                    >
                      Packed ({storeFilteredData.filter(r => r.is_packed).length})
                    </Button>

                    {/* UNPACKED BUTTON - Turns gray (inherit) if count is 0 */}
                    <Button 
                      variant={filterTab === "unpacked" ? "contained" : "outlined"} 
                      color={currentUnpackedCount > 0 ? "error" : "inherit"}
                      onClick={() => setFilterTab("unpacked")}
                      size="small"
                      sx={{ 
                        opacity: currentUnpackedCount > 0 ? 1 : 0.6,
                        fontWeight: currentUnpackedCount > 0 ? 'bold' : 'normal'
                      }}
                    >
                      Unpacked ({currentUnpackedCount})
                    </Button>
                  </div>
                </div>
                {/* ONLY SHOW TOGGLE IF A STORE RESTRICTION EXISTS */}
                {assignedStoreName !== "" && (
                <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#f8f9fa', padding: '4px', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                  <Button
                    size="small"
                    variant={!showAllLocations ? "contained" : "text"}
                    onClick={() => setShowAllLocations(false)}
                    sx={{ 
                        fontSize: '10px', 
                        fontWeight: 'bold', 
                        borderRadius: '6px',
                        boxShadow: !showAllLocations ? 1 : 0 
                    }}
                  >
                    MY STORE
                  </Button>
                  <Button
                    size="small"
                    variant={showAllLocations ? "contained" : "text"}
                    color="warning"
                    onClick={() => setShowAllLocations(true)}
                    sx={{ 
                        fontSize: '10px', 
                        fontWeight: 'bold', 
                        borderRadius: '6px',
                        boxShadow: showAllLocations ? 1 : 0 
                    }}
                  >
                    ALL STORES
                  </Button>
                </Box>
                )}
              </div>

              <Divider />

             <Box 
                sx={{ 
                  width: '100%', 
                  display: 'flex', 
                  flexDirection: 'column',
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                }}
              >
                <DataGrid
                  getRowId={(row) => row.line_item_id} 
                  rows={filteredRows}
                  columns={columns1}
                  loading={orderpicklistitems?.orderpickdetail?.loading}
                  autoHeight
                  rowHeight={40}
                  columnHeaderHeight={42}
                  hideFooter={filteredRows.length === 0} 
                  getRowClassName={(params) => 
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'
                  }

                  disableRowSelectionOnClick
                  density="comfortable"
                  disableColumnFilter={true}
                  disableColumnMenu={true}
                  slots={{
                    NorowsData, // Just pass the component reference
                  }}
                />
              </Box>
            </Card>
          )}
        
             <Card
                sx={{ 
                  marginTop: "20px", 
                  position: 'relative', // CRITICAL: Allows absolute positioning of the bar
                  overflow: 'hidden', // Ensures the bar corners match the card rounding
                  borderTop: 'none' 
                }}
                className="sc--cardhead--details"
              >
                {/* VISUAL PROGRESS BAR CONTAINER */}
                <Box 
                  sx={{ 
                    width: '100%', 
                    height: '8px', // Slightly thicker for better visibility
                    backgroundColor: '#f0f0f0', 
                    position: 'absolute', 
                    top: 0, 
                    left: 0,
                    zIndex: 100 // High z-index to stay above everything
                  }}
                >
                  <Box 
                    sx={{ 
                      width: `${packingProgress}%`, 
                      height: '100%', 
                      backgroundColor: packingProgress === 100 ? '#2e7d32' : '#1976d2', 
                      transition: 'width 0.6s cubic-bezier(0.4, 0, 0.2, 1)', // Smoother animation
                      boxShadow: packingProgress > 0 ? '0px 0px 8px rgba(25, 118, 210, 0.5)' : 'none'
                    }} 
                  />
                </Box>
                
                <div style={{ width: "100%", background: "#fff", paddingTop: '8px' }}>
                 <CardHeader
                    title={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.1rem' }}>
                          Order Package Details
                        </Typography>
                        {/* BETA USE ONLY BADGE */}
                        <Box 
                          sx={{ 
                            backgroundColor: '#fba94b', // The orange color from your image
                            color: '#fff',
                            padding: '10px 12px',
                            borderRadius: '15px', // Pill shape
                            fontSize: '10px',
                            fontWeight: 'bold',
                            letterSpacing: '0.5px',
                            textTransform: 'uppercase'
                          }}
                        >
                          BETA USE ONLY
                        </Box>
                        {packingProgress > 0 && (
                          <Box 
                            sx={{ 
                              backgroundColor: packingProgress === 100 ? '#e8f5e9' : '#e3f2fd',
                              color: packingProgress === 100 ? '#2e7d32' : '#1976d2',
                              padding: '2px 10px',
                              borderRadius: '12px',
                              fontSize: '11px',
                              fontWeight: 'bold',
                              letterSpacing: '0.5px'
                            }}
                          >
                            {packingProgress}% COMPLETE
                          </Box>
                        )}
                      </Box>
                    }
                    action={
                      <>
                        {orderpicklistitems &&
                          orderpicklistitems.orderpickdetailitems &&
                          orderpicklistitems.orderpickdetailitems.data &&
                          Object.keys(
                            orderpicklistitems.orderpickdetailitems.data
                          ).length != 0 && (
                            <>
                              {orderpicklistitems &&
                              orderpicklistitems.orderpickdetailitems &&
                              orderpicklistitems.orderpickdetailitems.data &&
                              orderpicklistitems.orderpickdetailitems.data
                                .shipment ? (
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  onClick={()=>{
                                    setOrderId("")
                                    setorderSubmit(false)
                                    openLabelClick(orderpicklistitems.orderpickdetail.data)
                                  }}
                                  style={{
                                    marginRight: "15px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <LocalPrintshopOutlinedIcon
                                    style={{
                                      paddingRight: "10px",
                                    }}
                                  />
                                  Print Label
                                </Button>
                              ) : (
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  disabled={isLabelButtonDisable && (profile && profile.profile && profile.profile.disable_create_shipment ===false || typeof profile.profile.disable_create_shipment == "undefined")}
                                  style={{
                                    marginRight: "15px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    newOrderCreateCallback(orderpicklistitems.orderpickdetail.data,"check")
                                  }
                                >
                                  <AddCircleOutlineOutlinedIcon
                                    style={{
                                      paddingRight: "10px",
                                    }}
                                  />
                                  Create Label
                                </Button>
                              )}
                            </>
                          )}
                      </>
                    }
                  />
                  <Divider />
                  {orderpicklistitems &&
                    orderpicklistitems.orderpickdetailitemsupdate &&
                    orderpicklistitems.orderpickdetailitemsupdate.loading && (
                      <LinearProgress />
                    )}
                  <CardContent>
                    <div className="sc--form--center" style={{ flexDirection: 'column', width: '100%' }}>
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center', 
                          gap: '20px',
                          padding: '20px',
                          background: (yetpackedcount === 0 && packedcount > 0) ? '#f1f8e9' : 'transparent',
                          borderRadius: '12px',
                          transition: 'background 0.4s ease', // Smoother transition
                          border: (yetpackedcount === 0 && packedcount > 0) ? '1px solid #c8e6c9' : '1px solid transparent'
                        }}>
                          
                          {/* 1. Search Field */}
                          <TextField
                            disabled={ (yetpackedcount + packedcount === 0) || (yetpackedcount === 0 && packedcount > 0) } // Disable when done
                            label={isBarcodeEnabled ? "Scan Barcode" : "Scan SKU"}
                            size={"small"}
                            value={sku}
                            onInput={(e) => {
                              setSku(e.target.value);
                              setScanError(""); 
                            }}
                            variant="outlined"
                            onKeyUp={(event) => {
                              if (event.key === "Enter") handleScanSubmit();
                            }}
                            inputRef={(scanInput) => {
                              skuInputRef.current = scanInput;
                              if (orderId !== "" && orderSubmit) scanInput && scanInput.focus();
                            }}
                            sx={{ 
                              width: "300px",
                              backgroundColor: 'white',
                              '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                  borderColor: (yetpackedcount === 0 && packedcount > 0) ? '#2e7d32' : (scanError ? '#d32f2f' : 'rgba(0, 0, 0, 0.23)'),
                                }
                              }
                            }}
                          />

                          {(yetpackedcount === 0 && packedcount > 0) ? (
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                            <PulseBox 
                              sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: '8px', 
                                backgroundColor: '#2e7d32', 
                                color: 'white', 
                                padding: '8px 20px', 
                                borderRadius: '6px',
                                fontWeight: '700',
                                fontSize: '13px',
                                letterSpacing: '0.5px',
                                cursor: 'default'
                              }}
                            >
                              <CheckCircleIcon style={{ fontSize: '18px' }} />
                              STORE VERIFIED: ALL ITEMS PACKED
                            </PulseBox>
                            
                            {/* DYNAMIC NOTE FOR OTHER STORES */}
                            {otherStoreItemsCount > 0 ? (
                              <Typography 
                                variant="caption" 
                                style={{ 
                                  color: '#ed6c02', 
                                  fontWeight: '600', 
                                  backgroundColor: '#fff3e0',
                                  padding: '6px 15px',
                                  borderRadius: '4px',
                                  fontSize: '11px',
                                  border: '1px solid #ffe0b2',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px'
                                }}
                              >
                                <span>⚠️ ATTENTION: {otherStoreItemsCount} item(s) are still pending from other store locations.</span>
                                {!showAllLocations && (
                                  <Button 
                                    size="small" 
                                    onClick={() => setShowAllLocations(true)}
                                    sx={{ fontSize: '9px', height: '20px', color: '#ed6c02', border: '1px solid #ed6c02' }}
                                  >
                                    View Progress
                                  </Button>
                                )}
                              </Typography>
                            ) : (
                              <Typography variant="caption" style={{ color: '#666', fontWeight: '600', fontSize: '11px' }}>
                                Success: This order is fully packed across all stores.
                              </Typography>
                            )}
                          </div>
                        ) : (
                          <Button 
                            variant="contained" 
                            onClick={handleScanSubmit}
                            disabled={!sku}
                            sx={{ height: '40px', px: 4, fontWeight: 'bold' }}
                          >
                            SUBMIT SCAN
                          </Button>
                        )}
                        </div>
                        
                        {/* 3. Scan Error Text */}
                        {scanError && (
                          <Typography 
                            style={{ 
                              color: '#d32f2f', 
                              fontSize: '11px', 
                              fontWeight: 'bold', 
                              marginTop: '10px',
                              background: '#ffebee',
                              padding: '4px 12px',
                              borderRadius: '4px'
                            }}
                          >
                            ⚠️ {scanError}
                          </Typography>
                        )}
                      </div>
                    {columns && (
                      <>
                      <DragDropContext
                        onDragEnd={(result) =>
                          onDragEnd(result, columns, setColumns)
                        }
                      >
                        <div
                          className="sc--form--center"
                          style={{ margin: "40px 0",pointerEvents:orderpicklistitems.orderpickdetailitemsupdate.loading ? "none":"all"}}
                        >
                          <Container>
                            <TaskColumnStyles>
                              {Object.entries(columns).map(
                                ([columnId, column], index) => {
                                  return (
                                    <Droppable
                                      key={columnId}
                                      droppableId={columnId}
                                    >
                                      {(provided, snapshot) => (
                                        <TaskList
                                              ref={provided.innerRef}
                                              {...provided.droppableProps}
                                          >
                                              {/* --- STICKY HEADER SECTION --- */}
                                              <Box 
                                                  sx={{
                                                      position: 'sticky',
                                                      top: -15, // Matches the 15px padding of your TaskList to dock at the very top
                                                      zIndex: 10,
                                                      backgroundColor: '#f3f3f3', // Matches the TaskList background to hide items behind it
                                                      display: 'flex',
                                                      justifyContent: 'space-between',
                                                      alignItems: 'center',
                                                      pb: 1.5, // Space between header and first card
                                                      pt: 0.5,
                                                      mb: 1,
                                                      borderBottom: '1px solid #e0e0e0', // Subtle line to show the header is separate
                                                      // This prevents the white background of the cards from showing above the header
                                                      margin: '-15px -15px 10px -15px', 
                                                      padding: '10px 15px' 
                                                  }}
                                              >
                                                  <Title>{column.title}</Title>
                                                  
                                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                      {column.title === "YET to be packed" ? (
                                                          <>
                                                              <Tooltip title="yet to be packed count" placement="top">
                                                                  <Typography variant="body2"><b>{unitCounts.yetUnits}</b></Typography>
                                                              </Tooltip>
                                                              <Tooltip title="Move to be packed" placement="top">
                                                                  <Button
                                                                      variant="outlined"
                                                                      color="primary"
                                                                      size="small"
                                                                      disabled={orderpicklistitems.orderpickdetailitemsupdate.loading || !canMoveToPacked}
                                                                      onClick={movePacked}
                                                                      sx={{ minWidth: '40px', height: '32px' }}
                                                                  >
                                                                      <ArrowForwardIosIcon sx={{ fontSize: '14px' }} />
                                                                  </Button>
                                                              </Tooltip>
                                                          </>
                                                      ) : (
                                                          <>
                                                              <Tooltip title="packed count" placement="top">
                                                                  <Typography variant="body2"><b>{unitCounts.packedUnits}</b></Typography>
                                                              </Tooltip>
                                                              <Tooltip title="Move yet to be packed" placement="top">
                                                                  <Button
                                                                      variant="outlined"
                                                                      color="primary"
                                                                      size="small"
                                                                      disabled={orderpicklistitems.orderpickdetailitemsupdate.loading || !canMoveToYetPacked}
                                                                      onClick={moveYetPacked}
                                                                      sx={{ minWidth: '40px', height: '32px' }}
                                                                  >
                                                                      <ArrowBackIosIcon sx={{ fontSize: '14px' }} />
                                                                  </Button>
                                                              </Tooltip>
                                                          </>
                                                      )}
                                                  </Box>
                                              </Box>

                                              {/* CARDS LISTED BELOW */}
                                              {column.items.map((item, index) => (
                                                  <TaskCard
                                                      key={item.id} // Ensure you use item.id or unique key
                                                      item={item}
                                                      index={index}
                                                      isBarcodeEnabled={isBarcodeEnabled}
                                                      showAllLocations={showAllLocations}
                                                  />
                                              ))}
                                              {provided.placeholder}
                                          </TaskList>
                                      )}
                                    </Droppable>
                                  );
                                }
                              )}
                            </TaskColumnStyles>
                          </Container>
                        </div>
                      </DragDropContext>
                    
                   </>
                    )}
                  </CardContent>
                </div>
              </Card>
      </PicklistPageWrapper>
      <Printer
        isPrinted={isPrinted}
        setIsPrinted={setIsPrinted}
        print_url={printUrl}
      />

      <NewOrderCreateDrawer
        visible={newOrderCreateDrawerVisible}
        reportName={"ORDER_PICKLIST"}
        newOrderFormData={newOrderFormData}
        setNewOrderFormData={setNewOrderFormData}
        meta={meta}
        onClose={newOrderCreateOnClose}
        // isDuplicateOrder={isDuplicateOrder}
        setNewOrderCreateDrawerVisible={setNewOrderCreateDrawerVisible}
        // choosenTrackingNumber={choosenTrackingNumber}
        isShipmentCreationFlow={isShipmentCreationFlow}
        isRateAutoEnabled={isRateAutoEnabled}
        isReturnOrder={isReturnOrder}
        setIsReturnOrder={setIsReturnOrder}

      />
             
    </>
  );
};

export default OrderPicklistPage;
